import { render, staticRenderFns } from "./WashProductColor.vue?vue&type=template&id=3153b465&scoped=true&"
import script from "./WashProductColor.vue?vue&type=script&lang=js&"
export * from "./WashProductColor.vue?vue&type=script&lang=js&"
import style0 from "./WashProductColor.vue?vue&type=style&index=0&id=3153b465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153b465",
  null
  
)

export default component.exports